function initGeoPopup() {
  console.log('[geo] init called. readyState=', document.readyState);
  // Shopify Markets országlista (Liquidből)
  const shopifyMarkets = window.shopifyMarkets || [];
  // Csak a szállítható országok (allowlist) számítanak támogatottnak
  const shippableCountries = Array.isArray(window.shippableCountries) && window.shippableCountries.length
    ? window.shippableCountries
    : ['HU'];
  const supportedCountries = shippableCountries.map(code => {
    const market = (Array.isArray(shopifyMarkets) ? shopifyMarkets : []).find(m => m.code === code);
    return {
      code,
      name: market?.name || code,
      currency: market?.currency || ''
    };
  });
  
  if (sessionStorage.getItem('hasSeenGeoPopup') === 'true') {
    // Ha már látta a popupot ebben a böngészési munkamenetben, ne jelenjen meg újra
    return;
  }
  
  const popup = document.getElementById('geoLocationPopup');
  
  fetch('/browsing_context_suggestions.json')
    .then(response => response.json())
    .then(data => {
      const detectedCountry = data?.detected_values?.country?.handle?.toUpperCase() || '';
      const countryName = data?.detected_values?.country?.name || 'Unknown';

      // DEBUG LOGS
      console.log('Detected country:', detectedCountry);
      console.log('Shopify markets:', shopifyMarkets);
      console.log('Shippable allowlist:', shippableCountries);
      console.log('Supported countries (derived):', supportedCountries);

      // Mindig a Liquidből átvett country-t használd alapértelmezettnek, ha van
      const defaultCountry = window.currentCountry || detectedCountry || '';
      if (!defaultCountry) {
        showNormalGeoPopup('');
        return;
      }
      const isSupported = supportedCountries.some(c => c.code === defaultCountry);
      if (isSupported) {
        showNormalGeoPopup(defaultCountry);
      } else {
        showUnsupportedCountryMessage(countryName);
      }
    })
    .catch(() => {
      // Ha nincs info, akkor is a szállítható lista döntsön
      const cc = (window.currentCountry || '').toUpperCase();
      if (cc && !supportedCountries.some(c => c.code === cc)) {
        showUnsupportedCountryMessage(cc);
      } else {
        showNormalGeoPopup(cc || '');
      }
    });

  function showNormalGeoPopup(selectedCountryCode) {
    console.log('showNormalGeoPopup fut!', selectedCountryCode);
    console.log('popup elem:', popup);
    if (!popup) return;
    const t = window.geoTranslations || {};
    // Ország opciók a Markets listából
    const countryOptions = supportedCountries.map(item => ({
      code: item.code,
      name: item.name || item.code,
      currency: item.currency || ''
    }));
    // Országnevek több nyelven
    const countryNames = {
      HU: { hu: "Magyarország", en: "Hungary" },
      AT: { hu: "Ausztria", en: "Austria" },
      BE: { hu: "Belgium", en: "Belgium" },
      BG: { hu: "Bulgária", en: "Bulgaria" },
      CZ: { hu: "Csehország", en: "Czechia" },
      DK: { hu: "Dánia", en: "Denmark" },
      EE: { hu: "Észtország", en: "Estonia" },
      FI: { hu: "Finnország", en: "Finland" },
      FR: { hu: "Franciaország", en: "France" },
      GR: { hu: "Görögország", en: "Greece" },
      NL: { hu: "Hollandia", en: "Netherlands" },
      HR: { hu: "Horvátország", en: "Croatia" },
      PL: { hu: "Lengyelország", en: "Poland" },
      LV: { hu: "Lettország", en: "Latvia" },
      LT: { hu: "Litvánia", en: "Lithuania" },
      LU: { hu: "Luxemburg", en: "Luxembourg" },
      DE: { hu: "Németország", en: "Germany" },
      IT: { hu: "Olaszország", en: "Italy" },
      PT: { hu: "Portugália", en: "Portugal" },
      RO: { hu: "Románia", en: "Romania" },
      ES: { hu: "Spanyolország", en: "Spain" },
      SE: { hu: "Svédország", en: "Sweden" },
      SK: { hu: "Szlovákia", en: "Slovakia" },
      SI: { hu: "Szlovénia", en: "Slovenia" }
    };
    // Nyelv detektálása
    const localeRaw = window.currentLocale || window.shopLocale || '';
    const lang = localeRaw.substring(0,2).toLowerCase();
    console.log('window.currentLocale:', window.currentLocale, 'window.shopLocale:', window.shopLocale, '-> lang:', lang);
    
    // Fallback: ha üres a locale, nézzük meg a h1 szöveget
    let finalLang = lang;
    if (!lang || lang === '') {
      const h1Text = document.querySelector('h1')?.textContent || '';
      finalLang = h1Text.includes('Üdvözlünk') || h1Text.includes('Magyar') ? 'hu' : 'en';
      console.log('Fallback nyelv detektálás:', finalLang, 'h1 szöveg alapján');
    }
    const options = countryOptions.map(item =>
      `<option value="${item.code}"${item.code === selectedCountryCode ? ' selected' : ''}>${(countryNames[item.code] ? (finalLang === 'hu' ? countryNames[item.code].hu : countryNames[item.code].en) : item.name)} - ${item.currency}</option>`
    ).join('');
    popup.innerHTML = `
      <div class="geo-popup-content" role="dialog" aria-modal="true" aria-labelledby="geoPopupTitle" aria-describedby="geoPopupDesc">
        <h2 id="geoPopupTitle">${t.h01 || 'Welcome to Will\'s Smart Nutrition'}</h2>
        <p id="geoPopupDesc">${t.p01 || 'Please confirm your shipping location to continue to our online store.'}</p>
        <div class="geo-popup-card">
          <form id="LocalizationForm" class="shopify-localization-form">
            <select id="CountrySelect" name="country_code" aria-label="Select your country">
              ${options}
            </select>
            <button type="submit" class="button button--primary icon-with-text" id="ConfirmLocationButton" is="hover-button">
              <span class="btn-fill" data-fill></span>
              <span class="btn-text">${t.confirmButton || 'CONFIRM SHIPPING LOCATION'}</span>
            </button>
          </form>
        </div>
      </div>
    `;
    console.log('popup.innerHTML beállítva:', popup.innerHTML);
    popup.style.display = 'flex';
    document.body.classList.add('no-scroll');
     // Cookie consent sáv z-index csökkentése
    document.querySelectorAll('[class^="cky-"], [class*=" cky-"]').forEach(el => { 
      el.style.zIndex = '1000';
    });
    const form = document.getElementById('LocalizationForm');
    // Előző submit handlerek eltávolítása
    form.onsubmit = null;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);
      // Shopify localization endpoint hívása
      fetch('/localization', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).finally(() => {
        sessionStorage.setItem('hasSeenGeoPopup', 'true');
        document.body.classList.remove('no-scroll');
        popup.style.display = 'none';
        // A Shopify intézi a megfelelő market/domain kezelést – frissítünk
        window.location.reload();
      });
    });
  }

  function showUnsupportedCountryMessage(countryName) {
    const t = window.geoTranslations || {};
    console.log('showUnsupportedCountryMessage fut!', countryName);
    console.log('popup elem:', popup);
    if (!popup) return;
    popup.innerHTML = `
      <div class="geo-popup-content">
        <h2>${t.h02 || "We're so Sorry 😔!"}</h2>
        <p style="margin-bottom: 20px; font-size: 18px; line-height: 1.5;">
          <strong>${(t.p02 || 'Unfortunately, we currently do not ship ${countryName}.').replace('${countryName}', countryName)}</strong><br>
        </p>
        <button id="unsupported-country-acknowledge" class="button button--primary button--fixed">
          <span class="btn-fill" data-fill></span>
          <span class="btn-text">${t.understandButton || 'I understand'}</span>
        </button>
      </div>
    `;
    popup.style.display = 'flex';
    document.body.classList.add('no-scroll');
    document.querySelectorAll('[class^="cky-"], [class*=" cky-"]').forEach(el => {
      el.style.zIndex = '1000';
    });
    document.getElementById('unsupported-country-acknowledge').addEventListener('click', () => {
      popup.style.display = 'none';
      document.body.classList.remove('no-scroll');
      sessionStorage.setItem('hasSeenGeoPopup', 'true');
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGeoPopup);
} else {
  // Ha a DOM már kész, azonnal futtatjuk
  initGeoPopup();
}
